import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function EmailSettingsIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      id="Email_Settings_Icon"
      data-name="Email Settings Icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "18.998"}
      height={height || "12.637"}
      viewBox="0 0 18.998 12.637"
    >
      <path
        id="União_9"
        data-name="União 9"
        d="M13.789,12.637a.225.225,0,0,1-.219-.187l-.164-1.139a3.2,3.2,0,0,1-.75-.426l-1.107.432a.23.23,0,0,1-.273-.1l-.889-1.492a.221.221,0,0,1,.055-.273l.943-.711a2.363,2.363,0,0,1-.037-.42,3.3,3.3,0,0,1,.043-.428l-.937-.711a.2.2,0,0,1-.055-.275l.883-1.49a.223.223,0,0,1,.273-.1l1.1.432a3.327,3.327,0,0,1,.75-.426l.17-1.145A.215.215,0,0,1,13.789,4h1.777a.227.227,0,0,1,.225.182l.164,1.145a3.155,3.155,0,0,1,.75.426l1.107-.432a.218.218,0,0,1,.268.1l.889,1.49a.209.209,0,0,1-.055.275l-.937.711a2.346,2.346,0,0,1,.031.428,2.94,2.94,0,0,1-.025.42l.926.711a.2.2,0,0,1,.061.273l-.889,1.492a.225.225,0,0,1-.273.1L16.7,10.885a3.244,3.244,0,0,1-.75.426l-.164,1.139a.216.216,0,0,1-.219.188Zm-.773-4.314A1.666,1.666,0,1,0,14.678,6.7,1.641,1.641,0,0,0,13.016,8.322ZM9.381,10.5h.006Zm-8.07,0A1.313,1.313,0,0,1,0,9.186V3.6a.163.163,0,0,1,.16-.164.174.174,0,0,1,.1.035C.848,3.92,1.607,4.5,4.475,6.574c.055.037.109.08.172.127.035.031.066.057.1.086h.006A4.075,4.075,0,0,0,6.99,7.877H7.02a4.156,4.156,0,0,0,2.223-1.09l.012-.012c.037-.025.066-.055.1-.08l.023-.018A5.458,5.458,0,0,0,9,8.7a3.961,3.961,0,0,0,.383,1.8ZM7,7H6.99a3.676,3.676,0,0,1-1.711-.912l-.014-.014c-.109-.084-.2-.15-.273-.207C1.656,3.445,1.152,3.049.445,2.5L.414,2.477.25,2.35A.663.663,0,0,1,0,1.832V1.314A1.313,1.313,0,0,1,1.311,0H12.688A1.316,1.316,0,0,1,14,1.314v.518a.66.66,0,0,1-.256.518l-.072.055-.014.012c-.771.6-1.156.908-4.656,3.451-.072.057-.164.123-.268.2A3.713,3.713,0,0,1,7.014,7Z"
        fill={color || "#555"}
      />
    </svg>
  );
}
